import { makeStateKey } from "@angular/core";
import { HandledHttpResponse } from "@uzenith360/http-utils";
import GalleryPhotosListData from "./types/gallery-photos-list-data.inteface";

export default makeStateKey<HandledHttpResponse<GalleryPhotosListData | undefined>>('gallery-photos-list-data');